"use client"

import { useState } from "react"
import { HiVolumeOff, HiVolumeUp } from "react-icons/hi"
import { ChevronRight, Home } from "lucide-react"

const AboutHero = () => {
    const [isMuted, setIsMuted] = useState(true)

    const toggleMute = () => {
        setIsMuted(!isMuted)
    }

    return (
        <section className="relative w-full bg-white">
            <style dangerouslySetInnerHTML={{
                __html: `
                @keyframes bounce-horizontal {
                    0%, 100% { transform: translateX(0); animation-timing-function: cubic-bezier(0.8, 0, 1, 1); }
                    50% { transform: translateX(-25%); animation-timing-function: cubic-bezier(0, 0, 0.2, 1); }
                }
            `}} />

            <div className="relative w-full px-4 md:px-6 xl:px-8 2xl:px-10 min-[1920px]:px-12">
                <div className="relative w-full h-[280px] md:h-[360px] xl:h-[420px] 2xl:h-[480px] min-[1920px]:h-[560px] rounded-2xl overflow-hidden group">
                    <video
                        className="absolute inset-0 w-full h-full object-cover scale-105"
                        autoPlay
                        loop
                        muted={isMuted}
                        playsInline
                    >
                        <source src="/videos/BannerAbout.mp4" type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>

                    <div className="absolute inset-0 bg-black/20" />

                    {/* Breadcrumb */}
                    <div className="hidden md:flex absolute top-2 left-2 xl:top-4 xl:left-4 2xl:top-5 2xl:left-5 min-[1920px]:top-8 min-[1920px]:left-8 items-center gap-1 text-white z-20"
                        style={{ fontFamily: '"Plus Jakarta Sans", sans-serif' }}   >
                        <Home className="size-3 xl:size-3.5 2xl:size-4 min-[1920px]:size-5" strokeWidth={2} />
                        <ChevronRight className="size-2.5 xl:size-3 2xl:size-3.5 min-[1920px]:size-4 opacity-70" />
                        <span className="text-[10px] xl:text-xs 2xl:text-[13px] min-[1920px]:text-base font-light tracking-wide">Về chúng tôi</span>
                    </div>

                    <div className="absolute bottom-10 2xl:bottom-14 min-[1920px]:bottom-20 left-1/2 -translate-x-1/2 w-full text-center px-4 z-20">
                        <h1 className="text-[#FFFFFF] text-xl md:text-3xl xl:text-4xl 2xl:text-5xl min-[1920px]:text-6xl font-normal tracking-tight text-balance"
                            style={{ fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
                            Rovi Holdings – kết nối hành trình <br /> chạm đến tương lai
                        </h1>
                    </div>

                    {/* Nút bật/tắt âm thanh */}
                    <div className="absolute bottom-3 right-3 md:bottom-6 md:right-6 2xl:bottom-8 2xl:right-8 min-[1920px]:bottom-10 min-[1920px]:right-10 z-20 transition-opacity">
                        <button
                            onClick={toggleMute}
                            className="p-1.5 md:p-2 2xl:p-2.5 min-[1920px]:p-3 bg-black/40 backdrop-blur-md border border-white/20 rounded-full text-white hover:bg-black/60 transition-all"
                        >
                            {isMuted ?
                                <HiVolumeOff className="size-3.5 md:size-4 2xl:size-5 min-[1920px]:size-6" /> :
                                <HiVolumeUp className="size-3.5 md:size-4 2xl:size-5 min-[1920px]:size-6" />
                            }
                        </button>
                    </div>
                </div>

                {/* Scroll Down */}
                <div className="hidden md:block absolute bottom-20 md:bottom-24 xl:bottom-30 2xl:bottom-36 min-[1920px]:bottom-44 right-0 -translate-x-1 min-[1920px]:-translate-x-2 -rotate-90 origin-bottom-right z-12">
                    <div className="flex items-center gap-2 2xl:gap-2.5 min-[1920px]:gap-3.5 text-black/60">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1"
                            stroke="currentColor"
                            className="w-4 h-4 xl:w-5 xl:h-5 2xl:w-[22px] 2xl:h-[22px] min-[1920px]:w-7 min-[1920px]:h-7"
                            style={{ animation: 'bounce-horizontal 1s infinite' }}
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
                        </svg>
                        <p className="font-normal tracking-[0.12em] text-[9px] xl:text-[10px] 2xl:text-[13px] min-[1920px]:text-[16px] uppercase whitespace-nowrap">Scroll Down</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AboutHero